var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.935 27.021",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.084 18.137a3.074 3.074 0 1 0-3.078-3.073 3.075 3.075 0 0 0 3.078 3.073z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.53,
    cy: 2.539,
    r: 2.561
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24.021H0v3h19.5a1.5 1.5 0 0 0 0-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.817 20.234c-.331-.742-1.246-.986-1.884-.782l-4.665 2.231c-.742-.469-3.583-2.205-5.281-3.295a5.613 5.613 0 0 0-.902-1.012 5.574 5.574 0 0 0-4.429-1.309L0 18v5.021h19.668c1.292 1 3.393 1.64 3.393 1.64.919.412 1.188.36 1.695.138l5.396-2.577c.577-.337.997-1.245.665-1.988zM5 10.5a.5.5 0 0 1 1 0v5.521h1.001L13 15.152V10.5a.5.5 0 0 1 1 0v4.545c.146-.01.291-.03.436-.03.533 0 1.054.087 1.564.213V8.939a2.92 2.92 0 0 0-2.939-2.918H5.939A2.92 2.92 0 0 0 3 8.939v7.082h2V10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatr);
export default __webpack_public_path__ + "static/media/MATR.23fb2b0587b45d6270b4e801bafe5b5f.svg";
export { ForwardRef as ReactComponent };